<dsw-footer cookies>
    <span version>Viessmann Account v{{ version }}</span>
</dsw-footer>
